import React from "react";
import Modal from "react-modal";
import { isEmbeddableTwinUrl } from "../utils/pointerra.js";
import "../css/PointerraModal.css";

function PointerraModal({ isOpen, onClose, embedUrl, subtitle }) {
    const canEmbed = isEmbeddableTwinUrl(embedUrl);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Digital Twin"
            className="pointerra-modal-content"
            overlayClassName="pointerra-modal-overlay"
        >
            <div className="pointerra-modal-header">
                <span className="pointerra-modal-title">
                    Digital Twin{subtitle ? ` — ${subtitle}` : ""}
                </span>
                <button
                    type="button"
                    className="pointerra-modal-close"
                    onClick={onClose}
                    aria-label="Close digital twin"
                >
                    ×
                </button>
            </div>
            <div className="pointerra-modal-body">
                {!embedUrl && (
                    <div className="pointerra-modal-empty">
                        No 3D model available for this asset.
                    </div>
                )}
                {embedUrl && !canEmbed && (
                    <div className="pointerra-modal-empty">
                        This 3D link cannot be displayed here — it needs to be a
                        Pointerra embed link.
                        <br />
                        <a
                            href={embedUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open in a new tab
                        </a>
                    </div>
                )}
                {embedUrl && canEmbed && (
                    <iframe
                        title="Pointerra Digital Twin"
                        src={embedUrl}
                        allow="fullscreen"
                        className="pointerra-modal-iframe"
                    />
                )}
            </div>
        </Modal>
    );
}

export default PointerraModal;
